import { memo } from 'react';
import PropTypes from 'prop-types';

import { TextField } from 'basic-components';
import { DataScienceEnums } from 'dashboard-services/api/dataScience';

/* eslint-disable no-unused-vars */
const Text = ({
  value,
  valueType,
  validators,
  onChange,
  size = undefined,
  menuPosition = undefined,
  animationEnded = undefined,
  dependsOnParam = undefined,
  extraGroupQuery = undefined,
  referenceDependsOnParam,
  withProvider,
  readableName,
  menuPortalTarget,
  ref,
  ...props
}) => {
/* eslint-enable no-unused-vars */
  const getPlaceholder = () => {
    switch(valueType) {
      default:
      case DataScienceEnums.TASK_PARAM_VALUE_TYPE.STRING:
        return "Type text"
      case DataScienceEnums.TASK_PARAM_VALUE_TYPE.NUMBER:
        return "Type number"
    }
  }
  const getType = () => {
    switch(valueType) {
      default:
      case DataScienceEnums.TASK_PARAM_VALUE_TYPE.STRING:
        return undefined
      case DataScienceEnums.TASK_PARAM_VALUE_TYPE.NUMBER:
        return "number"
    }
  }

  return (
      <TextField
          {...props}
          autoComplete="new-password"
          defaultValue={value ? typeof value === "object" ? JSON.stringify(value) : String(value) : value}
          onChange={onChange}
          placeholder={getPlaceholder()}
          ref={ref}
          size={size}
          type={getType(valueType)}
          validators={validators}
      />
  )
}

Text.displayName = "Text"


Text.propTypes = {
  animationEnded: PropTypes.bool,
  dependsOnParam: PropTypes.object,
  extraGroupQuery: PropTypes.string,
  menuPosition: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  size: PropTypes.string,
  validators: PropTypes.array.isRequired,
  value: PropTypes.any.isRequired,
  valueType: PropTypes.string.isRequired, 
}

export default memo(Text);